import { useTranslation } from 'react-i18next';

import { useMediaQuery } from '@mui/material';

import Typography from '../../../components/Typography';
import { i18nNS } from '../../../i18n';
import { forMobile } from '../../../utils/media-queries';
import Message from './Message';
import { Root } from './styles';
import useNoCoursesCardVM from './vm';

const NoCoursesCard = () => {
  const { t } = useTranslation([i18nNS.COURSES, i18nNS.COMMON]);
  const isMobile = useMediaQuery(forMobile);

  const { name, hasCourses } = useNoCoursesCardVM();

  if (hasCourses) return null;

  return (
    <Root>
      <Typography variant="h2Bold" color="grey.800" noWrap={!isMobile} maxWidth="100%">
        {t('hey_name_exclamation', { ns: i18nNS.COMMON, name })}
      </Typography>
      <Message />
    </Root>
  );
};

export default NoCoursesCard;
